import { cn } from '@talentmesh/ui/lib/utils';
import { cloneElement } from 'react';

interface TimelineChipProps extends React.ComponentProps<'div'> {
    label: string;
    icon: React.JSX.Element;
}

const TimelineChip = ({ label, icon, ...props }: TimelineChipProps) => {
    const iconWithInheritedColor = cloneElement(icon, { className: cn('size-4', icon.props.className) });

    return (
        <div {...props}>
            <div className="text-blueish-foreground bg-blueish flex h-8 w-fit items-center gap-1 rounded-lg px-2 py-1 [&>svg]:size-5">
                {iconWithInheritedColor}
                <span>{label}</span>
            </div>
        </div>
    );
};

export default TimelineChip;
